import React from 'react';
import { ReactComponent as TreePalm } from 'products/global/assets/img/join-us/benefits/tree-palm.svg';
import { ReactComponent as Heart } from 'products/global/assets/img/join-us/benefits/heart.svg';
import { ReactComponent as PlantRinged } from 'products/global/assets/img/join-us/benefits/planet-ringed.svg';
import { ReactComponent as Clock } from 'products/global/assets/img/join-us/benefits/clock.svg';
import { ReactComponent as UmbrellBeach } from 'products/global/assets/img/join-us/benefits/umbrella-beach.svg';
import { ReactComponent as CalendarStar } from 'products/global/assets/img/join-us/benefits/calendar-star.svg';
import { ReactComponent as GraduationCap } from 'products/global/assets/img/join-us/benefits/graduation-cap.svg';
import { ReactComponent as Seedling } from 'products/global/assets/img/join-us/benefits/seedling.svg';
import { ReactComponent as ChairOffice } from 'products/global/assets/img/join-us/benefits/chair-office.svg';
import { ReactComponent as Coins } from 'products/global/assets/img/join-us/benefits/coins.svg';
import { ReactComponent as PizzaSlice } from 'products/global/assets/img/join-us/benefits/pizza-slice.svg';
import { ReactComponent as Gamepad } from 'products/global/assets/img/join-us/benefits/gamepad.svg';
import { ReactComponent as PeopleRoof } from 'products/global/assets/img/join-us/benefits/people-roof.svg';
import { ReactComponent as Laptop } from 'products/global/assets/img/join-us/benefits/laptop.svg';
import { ReactComponent as Plane } from 'products/global/assets/img/join-us/benefits/plane.svg';
import { ReactComponent as BabyCarriage } from 'products/global/assets/img/join-us/benefits/baby-carriage.svg';

export const SIZES = {
  small: 132,
  medium: 158,
  large: 184
};

export const BENEFITS = [
  {
    id: 0,
    name: 'Paid time off',
    description: 'Unlimited, including sick days and a mandate of minimum 4 weeks off.',
    size: 'small',
    icon: <TreePalm />
  },
  {
    id: 1,
    name: 'Health insurance',
    description:
      'You get global health insurance where you live (Remote Health) and travel insurance wherever you travel (Nomad Insurance).',
    size: 'small',
    icon: <Heart />
  },
  {
    id: 2,
    name: 'Work from anywhere',
    description: 'We have been fully remote since day 1.',
    size: 'small',
    icon: <PlantRinged />
  },
  {
    id: 3,
    name: 'Flexible hours',
    description:
      'Our core hours are from 8am to 10am PST, but outside of this window your schedule is flexible.',
    size: 'small',
    icon: <Clock />
  },
  {
    id: 4,
    name: 'Workshops & gatherings',
    description:
      'We hold regular internal workshops and town halls to help everyone in the company learn about what’s going on and connect with team members they might not see on a regular basis.',
    size: 'medium',
    icon: <CalendarStar />
  },
  {
    id: 5,
    name: 'Personal development',
    description:
      'You are responsible for your own personal growth. SafetyWing covers up to $1,000-$2,500/year in online courses, conferences, books, mentors/coaches, etc. It is strongly encouraged. Bring fresh ideas to work.',
    size: 'large',
    icon: <GraduationCap />
  },
  {
    id: 6,
    name: 'Plants',
    description:
      'We reimburse cost for plants for your home office, as long as you take a picture of it and post it to one of our Slack channels.',
    size: 'medium',
    icon: <Seedling />
  },
  {
    id: 7,
    name: 'Travel',
    description:
      'As we are fully remote, we don’t care what country you work from and you are free to travel (note that meeting hours are not good for extended stays in Asia).',
    size: 'medium',
    icon: <Plane />
  },
  {
    id: 8,
    name: 'Home office or co-working',
    description:
      '$500/year for all team members to upgrade your workspace or for co-working memberships/passes.',
    size: 'medium',
    icon: <ChairOffice />
  },
  {
    id: 9,
    name: 'Referral bonus',
    description:
      'SafetyWing encourages each and every team member to help find the best talent possible to reach our goals. To incentivize this, we will pay two bonuses for every person hired.',
    size: 'medium',
    icon: <Coins />
  },
  {
    id: 10,
    name: 'Virtual meals',
    description:
      'Each month you can use $25 to purchase a meal and eat it virtually or in person with another member of the SafetyWing team.',
    size: 'medium',
    icon: <PizzaSlice />
  },
  {
    id: 11,
    name: 'Laptop allowance',
    description:
      'SafetyWing will cover the cost of a laptop for full-time team members (specs depending on the nature of the role). This laptop is not considered company property and is yours to keep.',
    size: 'medium',
    icon: <Laptop />
  },

  {
    id: 12,
    name: 'Parental leave',
    description:
      'We offer full pay for up to 4 months for birth mothers and 2 months for co-parents.',
    size: 'medium',
    icon: <BabyCarriage />
  }
];
